import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import { CostService } from "../../../services/index";
import * as fromRootStore from "../../../reducers";
import { ComboService, SampleService } from "../../../services/index";

@Component({
  selector: "AddEditDStock",
  templateUrl: "./AddEditDStock.html",
})
export class AddEditDStock {
  auto_number: number;
  season_name: string;
  row: any;
  data: any;

  qualityList: any;
  typeList: any;
  coreList: any;
  shadeIndex: number = 0;
  gangList: any;
  coredesignList: any;
  gangdesignList: any;
  shadeTypeList: any = [];
  shadeTypeListExists: any = [];
  purchaseAgentList = [];
  seasonList = [];
  designColors: any = [];
  detailList: any = [];
  categoryData: any = [];
  saveDetect: boolean = false
  filter: any = {
    season: "",
    date: "",
    ref_no: "",
    combo_name: "",
    shirt_no: "",
    dhoti_no: "",
    style: "",
    variety: "",
    dp_shirt: 0,
    dp_dhoti: 0,
    margin: 0,
    combo_mrp: 0,
    fs_rate: 0,
    hs_rate: 0,
    category: ""
  };

  designnoList = [];
  dhotiNoList = [];
  shirtBarcodeDetails = [];
  dhotiBarcodeDetails = [];
  comboDetails = [];
  barcodeDisabled = false;


  shadeType = "";
  shadeColor = "";
  widthList: any[];
  // designTypeList = ["NEW", "CORE", "GANG"];
  // desData: any = {
  //   totalmtr: 0,
  //   totalamt: 0,
  // };
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);

    if (this.mode == "Edit" || this.mode == "View") {
      this.filter = designdata;
      this.filter.date = designdata.ref_date;
      this.setMainDetails(this.filter)
      this.getComboStockDetails();
    }
  }

  get params(): any[] {
    return this._params;
  }

  get validData() {
    return this.filter.shirt_no && this.filter.dhoti_no && this.filter.combo_name ? true : false;
  }

  tempData = [];

  @Output() tabUpdateEvent = new EventEmitter();
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  filteredOptions: Observable<string[]>;
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private costservice: CostService,
    private sampService: SampleService,
    private comboservice: ComboService,
  ) { }
  ngOnInit() {
    // this.getCategory();
    if (this.mode == "Add") {
      this.getAuto();
      this.getSeasonList();
      this.getDhotiComboList();
      // this.getPoDhotiList();
      this.filter.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    }
    this.tableScroll();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  tableScroll() {
    $(".purreturn").height(window.innerHeight - 60);
    $(".pobody").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getAuto() {
    this.sampService.getDhotiStkRefNumber({}).then((res: any) => {
      this.filter.ref_no = res;
    });
  }

  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSeason(params).then((res: any) => {
      let partialSeason = [];

      for (let i = res.length - 1; i > res.length - 10; i--) {
        partialSeason.push(res[i]);
      }

      let today = new Date();
      let curDate =
        today.getFullYear() +
        "-0" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();

      res.forEach((el) => {
        if (curDate >= el.order_from && curDate <= el.order_to) {
          this.filter.season = el.season;
        }
      });

      this.seasonList = partialSeason;
    });
  }

  getDhotiComboList() {
    let params = {
      page_from: 'D STOCK'
    };
    this.sampService.getDhotisampleList(params).then((res: any) => {
      this.designnoList = res.data;
    });
  }

  setMainDetails(event: any) {
    let params = {
      combo_stock_name: this.filter.combo_name
    };
    this.sampService.getDhotisampleList(params).then((res: any) => {
      this.comboDetails = res.data;
      this.filter.shirt_no = event.shirt_no;
      this.filter.dhoti_no = event.dhoti_no;
      console.log(this.comboDetails, "check Color Array")
    });


  }

  getBarcodeDetails(flag: string, event: any) {
    const params = {
      barcode: event.target.value
    }
    if (flag == "shirtBarcode") {
      if (params.barcode.length == 7) {
        const isExist = this.shirtBarcodeDetails.find((data) => data.barcode == params.barcode);
        if (!isExist) {
          this.barcodeDisabled = true;
          this.sampService.getShirtbarcodeDet(params).then((res: any) => {
            if (res.success && res.data) {
              console.log("filter :: ", this.filter);
              console.log("res.data :: ", res.data);
              if (res.data.design == this.filter.shirt_no) {
                if (this.comboDetails.find((data: any) => data.combo_color == res.data.color)) {
                  this.shirtBarcodeDetails.push(res.data);
                } else {
                  this.errorSwal("Shirt color not matched");
                }
              } else {
                this.errorSwal("Shirt no and Design no not matching");
              }
            } else {
              this.errorSwal(res.message);
            }
            this.barcodeDisabled = false;
            this.barcodeFocus(flag);
          });
        } else {
          this.errorSwal("Barcode already exist");
        }
        event.target.value = "";
      }
    } else if (flag == "dhotiBarcode") {
      if (params.barcode.length == 6) {
        const isExist = this.dhotiBarcodeDetails.find((data) => data.barcode == params.barcode);
        if (!isExist) {
          this.barcodeDisabled = true;
          this.sampService.getDhotiGrncodeDet(params).then((res: any) => {
            if (res.success && res.data) {
              if (res.data.design_no == this.filter.dhoti_no) {
                if (this.comboDetails.find((data: any) => data.dhoti_color == res.data.color)) {
                  this.dhotiBarcodeDetails.push(res.data);
                } else {
                  this.errorSwal("Dhoti color not matched");
                }
              } else {
                this.errorSwal("Dhoti no and Design no not matching");
              }
            } else {
              this.errorSwal(res.message);
            }
            this.barcodeDisabled = false;
            this.barcodeFocus(flag);
          });
        } else {
          this.errorSwal("Barcode already exist");
        }
        event.target.value = "";
      }
    }
  }

  errorSwal(message: string) {
    swal({
      type: "error",
      titleText: message,
      showCancelButton: false,
      showConfirmButton: false,
      timer: 2000
    });
  }

  barcodeFocus(id: string) {
    setTimeout(() => {
      document.getElementById(id).focus();
    }, 50);
  }

  getComboStockDetails() {
    let params = {
      inw_id: this.filter.inw_id
    };
    this.sampService.getComboStockDetails(params).then((res: any) => {
      if (res.success) {
        this.shirtBarcodeDetails = res.data.shirtDetails;
        this.dhotiBarcodeDetails = res.data.dhotiDetails;
      }
    });
  }

  deleteRow(flag: string, index: number) {
    if (flag == "shirtBarcode") {
      this.shirtBarcodeDetails.splice(index, 1);
    } else if (flag == "dhotiBarcode") {
      this.dhotiBarcodeDetails.splice(index, 1);
    }
  }

  addDStock() {
    if (this.shirtBarcodeDetails.length == this.dhotiBarcodeDetails.length) {
      this.filter.date = this.datePipe.transform(this.filter.date, "yyyy-MM-dd");
      let that = this;
      let params: any = Object.assign({}, this.filter);
      params["tabevent"] = undefined;
      params["shirtDetails"] = JSON.stringify(this.shirtBarcodeDetails);
      params["dhotiDetails"] = JSON.stringify(this.dhotiBarcodeDetails);
      params['mode'] = this.mode;

      swal({
        title: "Are you sure to save this Dhoti Stock?",
        type: "info",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.sampService.addCombodhotiStock(params).then(function (res: any) {
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: "Dhoti stock added successfully",
            });
            let tabObj = {
              action: "CloseTab",
              params: {},
            };
            that.tabUpdateEvent.emit(tabObj);
            that.saveEvent.emit(tabObj);
          } else {
            swal("ERROR", res.message, "error");
          }
        });
      });
    } else {
      swal("ERROR", "Shirt and Dhoti barcode should be equivalent", "error");
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/AddEditDStock.ts